import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import AOS from 'aos';

declare const lucide: any;
import {
  EASY_MIGRATION_IMAGE_PATH,
  BANNER_IMG,
  SECURITY_QUALITY,
  EPPS_ERP_PRODUCTIVITY,
  BUSINESS_DECISION_ICON,
  CONTINUOUES_ACCESSIBILITY,
  EMPOWERED_EMPLOYEES,
  ENHANCED_CUST_ENGAGEMENT,
  DEPLOYMENT_IMPLEMENTATION,
  CONSULTING_APPROACH,
  REPORTING_PLANNING,
  STREAMLINED_PROCESSES,
  INTEGRATED_INFORMATION,
  ACCURATE_INFORMATION,
  GST_READY,
  MULTI_CURRENCY,
  COMPATIBLE_MULTI,
  DOC_MANAGEMENT,
  MASTER_OPENING,
  THIRD_PARTY_LICENSING,
  AUDIT_TRAIL_LOG,
  MULTI_SMART_DEVICE,
  BAR_CODING_FLEXIBLE,
  NOTIFICATION_FOR_APPROVAL,
  BROADCAST_NOTIFICATION,
  INITIATIVE_USER_INTERFACE,
  MULTI_BROWSER_COMPATIBILITY,
  MULTI_LINGUAL_SUPPORT,
  EMAIL_SMS_INTEGRATION,
  BAR_CODING_QR_CODING,
  SMART_TCO_IMAGE,
  SMART_EXPERIENCE,
  SMART_TECHNOLOGY,
  HOME_BANNER_SALES,
  HOME_BANNER_SALES_MD,
  HOME_BANNER_SALES_SM,
  HOME_BANNER_SALES_XS,
  HOME_BANNER_PLATFORM,
  HOME_BANNER_INVENTORY,
  HOME_BANNER_INVENTORY_MD,
  HOME_BANNER_INVENTORY_SM,
  HOME_BANNER_INVENTORY_XS,
  HOME_REALTIMEBG_MD,
  HOME_REALTIMEBG_SM,
  HOME_REALTIMEBG_XS,
  HOME_BANNER_PLATFORM_MD,
  HOME_BANNER_PLATFORM_SM,
  HOME_BANNER_PLATFORM_XS,
  HOME_BANNER_INTUITIVEINTELLIGENT_MD,
  HOME_BANNER_INTUITIVEINTELLIGENT_SM,
  HOME_BANNER_INTUITIVEINTELLIGENT_XS,
  RUNNING_PARTNER_ICON,
  MANAGE_HIGH_VOL_ICON,
  FUTURE_TECH_ICON,
  EASY_MIGRATION_ICON,
  WAVEBG,
  OURCUSTOIMGONE,
  OURCUSTOIMGTWO,
  HOME_BANNER_ACCURATE_DECISION,
  HOME_REALTIMEBG,
  FANCYQUOTEICON,
  HOME_BANNER_INTUITIVEINTELLIGENT,
  DOTTED_BG_IMG,
  DOTTED_BG_IMG_FULL,
  CUST_BONY_IND,
  CUST_SURYA_LIFE,
  CALIPER_AUTO,
  JAYASHREE_ENT,
  SGCONTROL,
  CUST_ETE_ELE,
  EDEN_SPORTS,
  PROMPT_SUPPORT_ICON,
  THE_EPPS_SUCCESS_DRIVERS,
  EPPS_SMART_ERP_ADVANTAGE,


} from '../../assets/assets_constant';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { Meta, Title } from '@angular/platform-browser';
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers: [NgbCarouselConfig]
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  currentSlide = 0;
  totalSlides = 8;
  slideInterval: any;
  imagePath = EASY_MIGRATION_IMAGE_PATH;
  bannerImage: String = BANNER_IMG;
  productivityIcon: String = EPPS_ERP_PRODUCTIVITY;
  betterBusinessDecision = BUSINESS_DECISION_ICON;
  continuousAccessibilityIcon = CONTINUOUES_ACCESSIBILITY;
  empoweredEmployeesIcon = EMPOWERED_EMPLOYEES;
  enhancedCustomerEngagementIcon = ENHANCED_CUST_ENGAGEMENT;
  deploymentImplementation = DEPLOYMENT_IMPLEMENTATION;
  consultingApproch = CONSULTING_APPROACH;
  reportingPlanningIcon = REPORTING_PLANNING;
  securityQuilityIcon = SECURITY_QUALITY;
  streamesProcessesIcon = STREAMLINED_PROCESSES;
  integratedInfo = INTEGRATED_INFORMATION;
  accurateInfoIcon = ACCURATE_INFORMATION;
  gstReadyIcon = GST_READY;
  multiCurrencyIcon = MULTI_CURRENCY;
  compatibleMulti = COMPATIBLE_MULTI;
  docManagement = DOC_MANAGEMENT;
  masterOpeningIcon = MASTER_OPENING;
  thirdPartyLicensing = THIRD_PARTY_LICENSING;
  auditTrailLog = AUDIT_TRAIL_LOG;
  multiSmartDevice = MULTI_SMART_DEVICE;
  barCodingFlexible = BAR_CODING_FLEXIBLE;
  notificationForApproval = NOTIFICATION_FOR_APPROVAL;
  broadcastNotification = BROADCAST_NOTIFICATION;
  initiativeInterface = INITIATIVE_USER_INTERFACE;
  multiBrowserCompatibility = MULTI_BROWSER_COMPATIBILITY;
  multiLingualSupport = MULTI_LINGUAL_SUPPORT;
  emailSmsIntegration = EMAIL_SMS_INTEGRATION;
  barCodingQrCoding = BAR_CODING_QR_CODING;
  smartTcoImage = SMART_TCO_IMAGE;
  smartExperiance = SMART_EXPERIENCE;
  smartTechnology = SMART_TECHNOLOGY;
  homeBannerSalesImg: String = HOME_BANNER_SALES;
  homeBannerSalesImgMd: String = HOME_BANNER_SALES_MD;
  homeBannerSalesImgSm: String = HOME_BANNER_SALES_SM;
  homeBannerSalesImgXs: String = HOME_BANNER_SALES_XS;
  homeBannerPlatform: String = HOME_BANNER_PLATFORM;
  homeBannerPlatformMd: String = HOME_BANNER_PLATFORM_MD;
  homeBannerPlatformSm: String = HOME_BANNER_PLATFORM_SM;
  homeBannerPlatformXs: String = HOME_BANNER_PLATFORM_XS;
  homeBannerInventory: String = HOME_BANNER_INVENTORY;
  homeBannerInventryMd: String = HOME_BANNER_INVENTORY_MD;
  homeBannerInventryXs: String = HOME_BANNER_INVENTORY_XS;
  homeBannerInventrySm: String = HOME_BANNER_INVENTORY_SM;
  homeBannerAccurateDecision = HOME_BANNER_ACCURATE_DECISION;
  homeBannerIntuitiveIntelligent: String = HOME_BANNER_INTUITIVEINTELLIGENT;
  homeBannerIntuitiveIntelligentMd: String = HOME_BANNER_INTUITIVEINTELLIGENT_MD;
  homeBannerIntuitiveIntelligentSm: String = HOME_BANNER_INTUITIVEINTELLIGENT_SM;
  homeBannerIntuitiveIntelligentXs: String = HOME_BANNER_INTUITIVEINTELLIGENT_XS;
  homeRealtimeBg: String = HOME_REALTIMEBG;
  homeRealtimeBgMd: String = HOME_REALTIMEBG_MD;
  homeRealtimeBgSm: String = HOME_REALTIMEBG_SM;
  homeRealtimeBgXs: String = HOME_REALTIMEBG_XS;
  easyMigratioIcon = EASY_MIGRATION_ICON;
  manageHighVolIcon = MANAGE_HIGH_VOL_ICON;
  futureTechIcon = FUTURE_TECH_ICON;
  runningPartnerIcon = RUNNING_PARTNER_ICON;
  ourCustImgOne = OURCUSTOIMGONE;
  ourCustImgTwo = OURCUSTOIMGTWO;
  fancyQuoteIcon = FANCYQUOTEICON;
  waveBg = WAVEBG;
  custBoneInds = CUST_BONY_IND;
  suryaLife = CUST_SURYA_LIFE;
  caliperAuto = CALIPER_AUTO;
  jayashreeEnt = JAYASHREE_ENT;
  sgControl = SGCONTROL;
  eleLte = CUST_ETE_ELE;
  edenSports = EDEN_SPORTS;
  dottedBgImg = DOTTED_BG_IMG;
  dottedImgFull = DOTTED_BG_IMG_FULL;
  promptSupportIcon = PROMPT_SUPPORT_ICON;
  eppsSuccessDrivers = THE_EPPS_SUCCESS_DRIVERS;
  eppsSmartErpAdv = EPPS_SMART_ERP_ADVANTAGE;

  title = 'Best Cloud ERP System for Small & Medium Business';
  
  // For sci-fi particle animation
  particleArray = Array(50).fill(0).map((_, i) => i);

  // Slides array for pagination
  slides = Array(8).fill(0).map((_, i) => i);

  // Products with slide mapping
  products = [
    {
      title: 'EPPS Smart ERP',
      icon: 'layout',
      thumbnail: 'assets/images/epps-smart-erp-hero.png',
      shortDescription: 'Enterprise Resource Planning',
      slideIndex: 0,
      route: '/product'
    },
    {
      title: 'CITADEL',
      icon: 'shield-check',
      thumbnail: 'assets/images/citadel-hero.png',
      shortDescription: 'Cybersecurity & DRM',
      slideIndex: 1,
      route: '/prism'
    },
    {
      title: 'INDRA',
      icon: 'briefcase',
      thumbnail: 'assets/images/indra-hero.png',
      shortDescription: 'Defence Mess Management',
      slideIndex: 2,
      route: '/indra'
    },
    {
      title: 'SAMUDRA',
      icon: 'waves',
      thumbnail: 'assets/images/samudra-hero.png',
      shortDescription: 'Shipyard & Dockyard ERP',
      slideIndex: 3,
      route: '/samudra'
    },
    {
      title: 'HRMS',
      icon: 'users',
      thumbnail: 'assets/images/hrms-hero.png',
      shortDescription: 'HR & Payroll',
      slideIndex: 4,
      route: '/contact-us'
    },
    {
      title: 'AyuPravidha',
      icon: 'activity',
      thumbnail: 'assets/images/ayupravidha-hero.png',
      shortDescription: 'Naval Medical',
      slideIndex: 5,
      route: '/contact-us'
    }
  ];

  // Services with slide mapping
  services = [
    {
      title: 'Custom Development',
      icon: 'code',
      thumbnail: 'assets/images/technology-bright-neon-lights.jpg',
      shortDescription: 'Tailored solutions',
      slideIndex: 6,
      route: '/custom-software-development'
    },
    {
      title: 'Legacy Migration',
      icon: 'refresh-cw',
      thumbnail: 'assets/images/view-male-engineer-work-engineers-day-celebration (1).jpg',
      shortDescription: 'System modernization',
      slideIndex: 7,
      route: '/legacy-system-migration'
    }
  ];

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    AOS.init({
      duration: 2000,
      once: true
    });
    this.titleService.setTitle(this.title);
    this.metaService.addTags([
      { name: 'keywords', content: 'ERP, Smart ERP, EPPS' },
      { name: 'description', content: '' }
    ]);
  }

  ngAfterViewInit() {
    this.initializeSlider();
    this.startAutoSlide();
    this.initializeLucideIcons();
  }

  ngOnDestroy() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
  }

  initializeSlider() {
    // Initialize pagination dots
    const dots = document.querySelectorAll('.pagination-dot');
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Initialize thumbnail navigation
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    thumbnails.forEach((thumb) => {
      const slideIndex = parseInt(thumb.getAttribute('data-slide') || '0');
      thumb.addEventListener('click', () => this.goToSlide(slideIndex));
    });

    // Touch/swipe support
    let startX = 0;
    let endX = 0;

    const slider = document.querySelector('.hero-slider-container');
    if (slider) {
      slider.addEventListener('touchstart', (e: any) => {
        startX = e.touches[0].clientX;
      });

      slider.addEventListener('touchend', (e: any) => {
        endX = e.changedTouches[0].clientX;
        this.handleSwipe(startX, endX);
      });
    }

    // Set initial active states
    this.goToSlide(this.currentSlide);
  }

  startAutoSlide() {
    this.slideInterval = setInterval(() => {
      this.nextSlide();
    }, 5000); // Change slide every 5 seconds
  }

  goToSlide(slideIndex: number) {
    if (slideIndex === this.currentSlide) return;
    if (slideIndex < 0 || slideIndex >= this.totalSlides) return;

    // Remove active class from current slide, dot, and thumbnails
    const currentSlideEl = document.querySelector(`.hero-slide[data-slide="${this.currentSlide}"]`);
    const currentDot = document.querySelector(`.pagination-dot[data-slide="${this.currentSlide}"]`);
    const currentThumbnails = document.querySelectorAll(`.thumbnail-item[data-slide="${this.currentSlide}"]`);
    
    if (currentSlideEl) currentSlideEl.classList.remove('active');
    if (currentDot) currentDot.classList.remove('active');
    currentThumbnails.forEach(thumb => thumb.classList.remove('active'));

    // Add active class to new slide, dot, and thumbnails
    this.currentSlide = slideIndex;
    const newSlideEl = document.querySelector(`.hero-slide[data-slide="${this.currentSlide}"]`);
    const newDot = document.querySelector(`.pagination-dot[data-slide="${this.currentSlide}"]`);
    const newThumbnails = document.querySelectorAll(`.thumbnail-item[data-slide="${this.currentSlide}"]`);
    
    if (newSlideEl) newSlideEl.classList.add('active');
    if (newDot) newDot.classList.add('active');
    newThumbnails.forEach(thumb => thumb.classList.add('active'));

    // Reinitialize icons for the new slide
    setTimeout(() => {
      this.initializeLucideIcons();
    }, 100);

    // Reset auto-slide timer
    this.resetAutoSlide();
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.totalSlides;
    this.goToSlide(nextIndex);
  }

  previousSlide() {
    const prevIndex = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
    this.goToSlide(prevIndex);
  }

  handleSwipe(startX: number, endX: number) {
    const threshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.nextSlide();
      } else {
        this.previousSlide();
      }
    }
  }

  resetAutoSlide() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
    }
    this.startAutoSlide();
  }

  initializeLucideIcons() {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }

    // Re-initialize icons after a short delay to ensure DOM is ready
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 100);

    // Additional fallback for dynamic content
    setTimeout(() => {
      if (typeof lucide !== 'undefined') {
        lucide.createIcons();
      }
    }, 500);
  }
}

